// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3V-0V","col":"styles_col__3kqQd","fulfillmentStatus":"styles_fulfillmentStatus__1Ij9W","emailCol":"styles_emailCol__AEREK"};